import { LockerConflictDetails } from './types';

/** client.ts가 throw하는 에러 형태(+ 구조화 body) */
export type ApiErrorLike = Error & {
    status?: number;
    serverMessage?: string;
    body?: {
        code?: number;
        message?: string;
        errorCode?: string;
        details?: LockerConflictDetails;
    };
};

/** 라커 중복(다른 회원 점유) 경고 409인지 판별 */
export const isLockerConflict = (error: any): error is ApiErrorLike =>
    error?.status === 409 && error?.body?.errorCode === 'LOCKER_CONFLICT';

/**
 * 라커 중복 경고면 확인(2버튼) 다이얼로그를 띄우고, '추가하기' 선택 시 onConfirm 실행.
 * createAlert(title, content, isError, buttonContent, callBack, isTwoButton, twoButtonContent, twoButtonCallBack)
 *   - 우측(주) 버튼: buttonContent / callBack  → 강행(onConfirm)
 *   - 좌측(보조) 버튼: twoButtonContent / twoButtonCallBack → 취소(닫기)
 * @returns true = 중복으로 처리(다이얼로그 표시) / false = 다른 에러(호출부에서 일반 처리)
 */
export const handleLockerConflict = (
    error: any,
    createAlert: any,
    onConfirm: () => void,
    opts?: { title?: string; confirmText?: string },
): boolean => {
    if (!isLockerConflict(error)) return false;
    const message =
        error?.body?.message ||
        error?.serverMessage ||
        '이미 사용 중인 라커입니다. 그래도 추가하시겠습니까?';
    createAlert(
        opts?.title ?? '라커 중복 확인',
        message,
        true,
        opts?.confirmText ?? '추가하기',
        onConfirm,
        true,
        '취소',
        undefined,
    );
    return true;
};
